import React, {useState, useEffect, useRef, useReducer} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {loadDataForPatientLogin} from "../crudRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import Appointments from "../components/Appointments";
import {Heading, Box, Text} from "@chakra-ui/react";

export default function AppointmentsPage() {
  const navigate = useNavigate();
  const loadedRef = useRef(null);
  const {state} = useLocation();
  const [prevState, setPrevstate] = useState(state);
  const [dashState, dispatch] = useReducer(patientReducer, state, init);

  useEffect(function () {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  if (prevState !== state) {
    setPrevstate(state);
    dispatch({type: "UPDATE_STATE", payload: state});
  }

  useEffect(() => {
    if (dashState.patient && !dashState?.firstLoading) {
      loadDataForPatientLogin(
        {
          ...dashState,
          destination: "../appointments",
        },
        navigate
      );
    }
  }, []);

  useEffect(() => {
    let allowed = true;
    if (dashState?.firstLoading && allowed)
      navigate("../appointments", {
        state: {
          ...dashState,
          firstLoading: false,
        },
      });
    return () => {
      allowed = false;
    };
  }, []);

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      {state && (
        <Box
          display="flex"
          flex={1}
          overflow="hidden"
          flexDirection="column"
          w="100%"
          px={{base: 4, md: 6}}
          py={5}
        >
          <Box mb={4}>
            <Heading fontSize="xl" fontWeight="600" color="#1a1f36">
              Appointments
            </Heading>
            <Text fontSize="13px" color="#6b7280" mt={1}>
              View, manage, and book your appointments
            </Text>
          </Box>
          <Appointments {...{dashState, dispatch}} />
        </Box>
      )}
    </Layout>
  );
}
